if (!customElements.get("ac-split-tm-carousel")) {
  class AcSplitTmCarousel extends HTMLElement {
    connectedCallback() {
      this._slider = this.querySelector("ona-slider");
      this._prevIndex = 0;
      this._raf = null;
      this._slider.addEventListener("update", (event) => {
        const { activePanel, activeProgress } = event.detail;
        let blurProgress;
        if (activePanel.index === 0) {
          blurProgress = 0;
        } else if (activePanel.index > 1) {
          blurProgress = 1;
        } else {
          blurProgress = Math.floor(activeProgress * 10) / 10;
        }
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => {
          this.parentElement.style.setProperty("--blur-progress", blurProgress);
          this._raf = null;
        });
      });
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const align = isMobile ? "prev" : '{ "panel": "0%", "camera": "50%" }';
      this._slider.setAttribute("align", align);
      this._slider.init();
    }
  }
  customElements.define("ac-split-tm-carousel", AcSplitTmCarousel);
}
